<template>
  <el-dialog
    class="item-delivery-modal"
    width="90%"
    title="配件明细"
    v-loading="loading"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <data-table :columns="columns" :list="list" max-height="440px" />
    <div v-if="!isSaler && state === 0" style="text-align: right; margin-top:8px;">
      <el-button type="primary" size="mini" @click="doApprove()">审核</el-button>
      <el-button type="danger" size="mini" @click="doRefuse()">拒绝</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import DataTable from '@/components/DataTable'
export default {
  name: 'ApplyContextDetailModal',
  components: { DataTable },
  mixins: [ ModalMixin ],
  data () {
    return {
      loading: false,
      state: undefined,
      approveToken: undefined,
      list: [],
      columns: [
        {
          name: '类型',
          code: 'priceType',
          flexWidth: 0.5,
          renderFunc (val) {
            if (val === 1) {
              return '急件'
            } else if (val === 2) {
              return '海外件'
            } else if (val === 3) {
              return '兆配现货'
            } else {
              return '常规件'
            }
          }
        },
        {
          name: '品牌',
          code: 'brandName',
          flexWidth: 0.5
        },
        {
          name: '配件编号',
          code: 'partCode',
          flexWidth: 1
        },
        {
          name: '配件名称',
          code: 'partName',
          flexWidth: 1
        },
        {
          name: '4s进价',
          code: 'price4s',
          flexWidth: 0.6,
          renderFunc (val) {
            return val.toFixed(2)
          }
        },
        {
          name: '价格',
          code: 'price',
          flexWidth: 0.6
        },
        {
          name: '折扣',
          code: 'discount',
          flexWidth: 0.6,
          renderFunc (val, row) {
            let price = row.price
            if (!row.taxed) {
              price = +(row.price * 1.05).toFixed(2)
            }
            return (price / row.price4s).toFixed(2)
          }
        },
        {
          name: '数量',
          code: 'quantity',
          flexWidth: 0.5
        },
        {
          name: '是否含税',
          code: 'taxed',
          flexWidth: 0.6,
          renderFunc (val) {
            return val ? '是' : '否'
          }
        },
        {
          name: '门店',
          code: 'warehouse',
          flexWidth: 0.5
        }
      ]
    }
  },
  computed: {
    auth () {
      return this.$store.state.auth || {}
    },
    isSaler () {
      return this.auth.id !== 1
    }
  },
  methods: {
    init (applyContext, state, approveToken) {
      console.log(approveToken)
      this.approveToken = approveToken
      this.list = applyContext.orderList[0].items
      this.state = state
      return this.open()
    },
    doApprove () {
      window.open(`https://erp.zhaopeiyun.com/erp/reverseorder/approve?approverId=1&token=${this.approveToken}&state=1`, '_blank')
    },
    doRefuse () {
      window.open(`https://erp.zhaopeiyun.com/erp/reverseorder/approve?approverId=1&token=${this.approveToken}&state=3`, '_blank')
    }
  }
}
</script>
<style lang="stylus">
.item-delivery-modal
  .el-dialog
    max-width 840px
    .el-dialog__body
      padding-top 0
      max-height 640px
      overflow-x hidden
      overflow-y auto
      .base-data-table
        table
          tr
            td
              padding 0 4px
</style>
